import { useMemo } from 'react';
import { useAuth } from '@/providers/AuthProvider';
import { ApiClient, createApiClient } from './apiClient';

export const useApiClient = (): ApiClient => {
  const { getAccessToken } = useAuth();

  return useMemo(() => createApiClient(getAccessToken), [getAccessToken]);
};
